import { render, staticRenderFns } from "./ModalWhatsappEmLote.vue?vue&type=template&id=566f940c&"
import script from "./ModalWhatsappEmLote.vue?vue&type=script&lang=js&"
export * from "./ModalWhatsappEmLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports